import React from 'react';
import { Card, Table, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccOutsource } from '@/hooks/useWorkstationControlCenter';

interface Props {
  params?: WorkstationControlCenterQueryParams;
}

const OutsourceDependencyPanel: React.FC<Props> = ({ params }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useWccOutsource(params);
  const rows = (data as { rows?: Record<string, unknown>[] })?.rows ?? [];

  return (
    <Card
      id="outsource"
      title="Outsourced operation dependency"
      extra={<a onClick={() => navigate('/mfg/reports/outsourced-fabrication')}>Report</a>}
      style={{ marginTop: 16 }}
    >
      <Table
        size="small"
        loading={isLoading}
        rowKey={(r, i) => `${r.work_order_id}-${i}`}
        dataSource={rows}
        columns={[
          { title: 'WO', dataIndex: 'work_order_number' },
          { title: 'Operation', dataIndex: 'operation_name' },
          { title: 'Unit', dataIndex: 'production_unit_number', width: 60 },
          { title: 'PR', dataIndex: 'pr_number' },
          {
            title: 'Trace',
            dataIndex: 'outsourced_trace_status',
            render: (s: string) => <Tag>{s}</Tag>,
          },
          {
            title: 'Vendor delay',
            dataIndex: 'vendor_delay',
            render: (v: boolean) => (v ? <Tag color="red">Yes</Tag> : <Tag>OK</Tag>),
          },
        ]}
        pagination={{ pageSize: 10 }}
      />
    </Card>
  );
};

export default OutsourceDependencyPanel;
